import { Notification } from '@copera/notification';
import { useEffect, useRef } from 'react';
import { useBrowserNotification } from 'src/features/Notifications/shared/useBrowserNotification';
import { Queue } from 'src/utils/Queue';
import { AudioType, useAudio } from '../../../audio';
import { useInAppNotification } from '../useInAppNotification';

const queue = new Queue<Notification>();

export const useNotification = () => {
  const windowsHasFocus = useRef(true);
  const browser = useBrowserNotification();
  const audio = useAudio();
  const inApp = useInAppNotification();

  useEffect(() => {
    const onFocus = () => {
      windowsHasFocus.current = true;
    };

    const onBlur = () => {
      windowsHasFocus.current = false;
    };

    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, []);

  const consume = () => {
    if (queue.isRunning()) {
      return;
    }

    const notification = queue.dequeue();

    if (!notification) return;

    if (!windowsHasFocus.current) {
      browser.notify(notification);
    } else {
      inApp.notify(notification);
    }

    audio.play(AudioType.NOTIFICATION);

    queue.ack();

    if (!queue.isEmpty()) {
      consume();
    }
  };

  return {
    notify: (notification: Notification) => {
      queue.enqueue(notification);
      consume();
    },
  };
};
